import lottie from 'lottie-web';
import makeLottiePlayer from './makeLottiePlayer';

export default makeLottiePlayer(lottie);
